import { z } from "zod";
import { CustomerGroup, SaveCustomerGroupDto } from "@/lib/api";

/** Mesmos limites da API (Validators/CustomerGroupValidators.cs). */
export const customerGroupFormSchema = z.object({
  code: z.string().trim().min(1, "Informe o código do grupo.").max(100, "Use no máximo 100 caracteres."),
  name: z.string().trim().max(255, "Use no máximo 255 caracteres."),
  magentoGroupId: z
    .string()
    .trim()
    .refine((value) => value === "" || /^\d+$/.test(value), "Informe um número inteiro, sem sinal."),
});

export type CustomerGroupFormValues = z.infer<typeof customerGroupFormSchema>;

export const toCustomerGroupFormValues = (group?: CustomerGroup | null): CustomerGroupFormValues => ({
  code: group?.code ?? "",
  name: group?.name ?? "",
  magentoGroupId: group?.magentoGroupId != null ? String(group.magentoGroupId) : "",
});

export const toSaveCustomerGroupDto = (values: CustomerGroupFormValues): SaveCustomerGroupDto => ({
  code: values.code.trim(),
  name: values.name.trim() || null,
  magentoGroupId: values.magentoGroupId.trim() === "" ? null : Number(values.magentoGroupId),
});
